import axios from 'axios'

import {FETCH_RECENT, FETCH_DEPOSITS, FETCH_VERIFICATIONS} from "./index"

export function fetchRecents() {
  return function (dispatch) {
    dispatch({type: FETCH_RECENT.PENDING});
    axios.all([axios.get("/verifications?sort=-_id"), axios.get("/deposits?sort=-_id")])
      .then(axios.spread(function (verifs, depos) {
        // Both requests are now complete
        dispatch({type: FETCH_RECENT.SUCCESS, payload: [verifs.data.data, depos.data.data]});
        console.log(verifs)
        console.log(depos)
      }))
      .catch((err) => {
        dispatch({type: FETCH_RECENT.ERROR, payload: err})
      })
  }
}


// WEBPACK FOOTER //
// ./src/actions/dashboardActions.js